import InvalidElement from '../../../../domain/Folder/InvalidElementInterface'
import { ViewPageInterface } from '../../../../domain/ViewDossier/ViewPage'
import PresentationBlock from './PresentationBlock'

interface Props {
  page: ViewPageInterface,
  state: string | null
  invalidElements: InvalidElement[]
  onInvalidateToggle: (
    isInvalid: boolean,
    elementId: string,
    comment: string,
    blockId: string,
    receiptId: string | null,
    value: string | null,
    pageId: string,
  ) => void
  onCommentChange: (elementId: string, receiptId: string|null, comment: string) => void
}

const PresentationPage = ({ page, state, invalidElements, onInvalidateToggle, onCommentChange }: Props): JSX.Element => {
  return (
    <>
      {page.blocks.map((block) => {
        return <PresentationBlock
          block={block}
          key={block.id}
          state={state}
          pageId={page.id}
          invalidElements={invalidElements}
          onInvalidateToggle={onInvalidateToggle}
          onCommentChange={onCommentChange}
        />
      })}
    </>
  );
};

export default PresentationPage
